import React from "react";

export const LeadContext = React.createContext({});
